import styled from "styled-components";
import { PLAY_PANEL_EXHIBITION } from "test/mock/play/panel_exhibition";
import PlayAreas from "../PlayPanel/PlayAreas";

const TestPlayPanel = () => {
  return (
    <DivPlayPanel>
      <PlayAreas playAreas={PLAY_PANEL_EXHIBITION.areas} />
    </DivPlayPanel>
  );
};

const DivPlayPanel = styled.div`
  display: grid;
  margin-top: 0rem;
  margin-bottom: 0rem;
  margin-left: 0rem;
  margin-right: 0rem;
  height: 100%;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr;
  gap: 0rem 0rem;
  background-color: DimGrey;

  &&& div {
    overflow: hidden;
  }
`;

export default TestPlayPanel;
